import React, { ChangeEvent, useEffect, useState } from "react";
import { TransitionProps } from "@mui/material/transitions";
import { Button, Dialog, DialogContent, Slide, Stack, TextField } from "@mui/material";
import { Pocket, PocketRequest } from "../logic/types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import {useLifePlatformApiClient} from "../hooks/useLifePlatformApiClient";

export type Props = {
  show: boolean
  onClose: () => void
  onChangedPocket: () => void
  pocket: Pocket
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} children={props.children} />;
});

export default function ChangePocketDialog(props: Props) {
  const closeDialog = () => {
    props.onClose()
  }

  const {apiChangePocket} = useLifePlatformApiClient();
  const [title, setTitle] = useState("")

  useEffect(() => {
    setTitle(props.pocket.title)
  }, [props.pocket.title])

  async function onChangePocket() {
    console.log('STEP onChangePocket')

    const request: PocketRequest = {
      title: title
    }

    const changed = await apiChangePocket(props.pocket.id, request)
    if (changed) {
      if (props.onChangedPocket)
        props.onChangedPocket()
      closeDialog()
    }
  }

  function handleChangeTitle(event: ChangeEvent<HTMLInputElement>) {
    setTitle(event.target.value)
  }

  function validateForm(): boolean {
    return title.length > 0;
  }

  return (
    <Dialog
      fullScreen
      open={props.show}
      onClose={closeDialog}
      TransitionComponent={Transition}
    >
      <AppBar
        style={{backgroundColor: "#6750A4"}}
        sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={closeDialog}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>

          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            создать кошелёк
          </Typography>
          <Button color="inherit"
                  onClick={onChangePocket}
                  disabled={!validateForm()}>
            Изменить
          </Button>
        </Toolbar>
      </AppBar>

      <DialogContent>
        <Stack component="form" spacing={2}>
          <TextField
            autoFocus
            label="Название"
            type="text"
            onChange={handleChangeTitle}
            value={title}
          />
        </Stack>
      </DialogContent>

    </Dialog>
  );
}